import { log, supabase } from ".";
import { sincronizarContactosCliente } from "./contactosCliente";

export const saveCliente = async (cliente) => {
  try {
    // Backstop (decisión de Ignacio, 2026-10-07: ningún cliente sin categoría). Último candado
    // antes del INSERT — si algún caller nuevo olvidara pedirla, rechaza acá en vez de crear un
    // cliente incompleto en silencio (10.177).
    if (!cliente?.categoria) {
      throw new Error("saveCliente: falta la categoría del cliente (obligatoria)");
    }
    const data = await supabase.insertReturning("clientes", cliente);

    if (!data || (Array.isArray(data) && data.length === 0)) throw new Error("Empty response");

    // Sincronizar contactos a tablas relacionales — mismo escritor único que la edición (10.229).
    // Cliente recién creado: `antes` siempre vacío, el cargo lo resuelve el escritor desde
    // `usuarios.cargo` de la persona (nunca "Director"/"Gerente de Marketing" inventados).
    const newId = Array.isArray(data) ? data[0]?.id : data?.id;
    if (newId) {
      if (cliente.contacto_agencia) {
        try {
          await sincronizarContactosCliente({
            clienteId: newId,
            lado: "agencia",
            antes: [],
            despues: [cliente.contacto_agencia],
          });
        } catch (e) {
          log.error("saveCliente: sync CCA", e);
        }
      }
      if (cliente.contacto_cliente) {
        try {
          await sincronizarContactosCliente({
            clienteId: newId,
            lado: "cliente",
            antes: [],
            despues: [cliente.contacto_cliente],
          });
        } catch (e) {
          log.error("saveCliente: sync CCC", e);
        }
      }
    }

    return data;
  } catch (error) {
    log.error("saveCliente", error);
    throw error;
  }
};
